import { Button } from "@mui/material";

export function BootErrorFallback() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 h-screen p-6 text-center">
      <h1 className="text-xl font-medium">Brandhub failed to load</h1>
      <p className="text-neutral-600">
        This can happen right after an update is released. Reloading usually
        fixes it.
      </p>
      <Button variant="contained" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </div>
  );
}
